import { type ReactNode } from 'react'

import { cn } from '@/lib/utils'

export default function PageTitle({
  title,
  subtitle,
  icon,
  className,
  rightSide,
}: {
  title: ReactNode
  subtitle?: ReactNode
  icon?: ReactNode
  className?: string
  rightSide?: ReactNode
}) {
  return (
    <div className="flex flex-col gap-8 md:flex-row md:justify-between">
      <div className="flex flex-col gap-3">
        <div className={cn('mt-5 flex flex-row gap-3 sm:items-center', className)}>
          {icon ? <div className="h-8 rounded-lg bg-primary p-2 text-white sm:h-auto">{icon}</div> : null}
          <h1 className="text-2xl font-bold text-primary sm:text-3xl">{title}</h1>
        </div>
        {subtitle ? <div className="text-sm text-muted-foreground">{subtitle}</div> : null}
      </div>
      {rightSide}
    </div>
  )
}
